import { Link } from "react-router-dom";

const testimonials = [
  {
    name: "网友 · 半夜刷瓜",
    text: "以前看爆料只看单方面说法，越看越上头。这里把双方的原文摆一起，才发现有些话真的对不上。",
    tag: "上班族",
  },
  {
    name: "网友 · 不站队的梨",
    text: "时间线那部分最有用，重叠区一标出来，谁在时间上打太极就很明显了。",
    tag: "内容爱好者",
  },
  {
    name: "网友 · 冷静看戏",
    text: "不喊口号也不带节奏，就是把各方说了什么、回避了什么列清楚，这种站反而更耐看。",
    tag: "老读者",
  },
];

const principles = [
  { icon: "ri-scales-3-line", title: "只对比不站队", desc: "不替任何一方下定论" },
  { icon: "ri-links-line", title: "标注来源数量", desc: "每方说法都标出来源" },
  { icon: "ri-history-line", title: "保留旧说法", desc: "后续新说法与旧说法并列" },
];

export default function BrandSection() {
  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="h-64 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20stacked%20document%20cards%20and%20magnifying%20glass%20shapes%20in%20coral%20red%2C%20amber%20gold%20and%20warm%20cream%20beige%2C%20minimalist%20magazine%20style%2C%20clean%20geometric%20composition%20on%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=900&seq=gossip-about-team&orientation=landscape"
                alt="吃瓜观测站 内容整理工作示意"
                title="吃瓜观测站 - 多方说法归档整理"
                className="h-full w-full object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-secondary-600">
              <i className="ri-shield-check-line"></i>
              关于吃瓜观测站
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              做一件很朴素的事：把说法摆齐
            </h2>
            <p className="mt-4 font-label text-sm leading-relaxed text-foreground-600 md:text-base">
              热点来得快，说法散得更快。吃瓜观测站把同一事件里各方的公开表述归档到同一页，保留每一条的说法原文和时间点。不删旧内容，不替谁下结论，让后来的读者能自己对照。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-base`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
                    {p.title}
                  </h3>
                  <p className="mt-1 font-label text-xs text-foreground-500">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">读者怎么说</h3>
          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-0.5 text-accent-500">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 font-label text-sm leading-relaxed text-foreground-700">
                  「{t.text}」
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-user-3-line"></i>
                  </span>
                  <span>
                    <span className="block font-label text-xs font-medium text-foreground-900">
                      {t.name}
                    </span>
                    <span className="block font-label text-[11px] text-foreground-500">{t.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-5 rounded-lg border border-background-200 bg-primary-50 p-6 sm:flex-row sm:items-center md:p-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              手上有新线索或发现说法出入？
            </h3>
            <p className="mt-2 font-label text-sm text-foreground-600">
              把原始截图或链接发给我们，核实后会归档到对应事件的「后续进展」。
            </p>
          </div>
          <Link
            to="/about#contact"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-line"></i>
            去投稿
          </Link>
        </div>
      </div>
    </section>
  );
}